<template>

    <div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title" v-if="!isLoading">{{ lang.get("projects.project") }} {{ editing ? 'wijzigen' : 'toevoegen' }}</h2>
                    </div>
                    <div class="box-body form-horizontal">
                        <div :class="{'form-group':true,'has-error':hasFormError('name')}">
                            <label class="control-label col-xl-4">{{ lang.get("projects.form.name") }}:</label>
                            <div class="col-xl-8">
                                <input type="text" v-model="data.name" class="form-control" tabindex="1" />
                                <div v-if="hasFormError('name')" class="help-block">{{ getFormErrors.filter(err => err.name === 'name')[0].errmsg }}</div>
                            </div>
                        </div>
                        <div :class="{'form-group':true,'has-error':hasFormError('shortname')}">
                            <label class="control-label col-xl-4">{{ lang.get("global.shortname") }}:</label>
                            <div class="col-xl-8">
                                <input type="text" v-model="data.shortname" class="form-control" maxlength="10" tabindex="1" />
                                <div v-if="hasFormError('shortname')" class="help-block">{{ getFormErrors.filter(err => err.name === 'shortname')[0].errmsg }}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.form.color") }}:</label>
                            <div class="col-xl-8">
                                <compact-picker :value="data.color" @input="updateColorValue"></compact-picker>
                            </div>
                        </div>
                        <div :class="{'form-group':true,'has-error':hasFormError('project')}">
                            <label class="control-label col-xl-4">{{ lang.get("projects.form.number") }}:</label>
                            <div class="col-xl-8">
                                <div class="input-group">
                                    <input type="text" v-model="data.projectnr" disabled class="form-control" tabindex="1" />
                                    <div class="input-group-addon">
                                        <input type="checkbox" :checked="data.project" :disabled="data.project" @click="setProject()" />
                                    </div>
                                </div>
                                <div v-if="hasFormError('project')" class="help-block">{{ getFormErrors.filter(err => err.name === 'project')[0].errmsg }}</div>
                            </div>
                        </div>
                        <div class="form-group" v-show="showAq">
                            <label class="control-label col-xl-4">{{ lang.get("projects.form.aqnumber") }}:</label>
                            <div class="col-xl-8">
                                <div class="input-group">
                                    <input type="text" v-model="data.aqnr" disabled class="form-control" tabindex="1" />
                                    <div class="input-group-addon">
                                        <input type="checkbox" :checked="data.aq" :disabled="data.aq" @click="setAq()" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :class="{'form-group':true,'has-error':hasFormError('source')}">
                            <label class="control-label col-xl-4">{{ lang.get("projects.source") }}:</label>
                            <div class="col-xl-8">
                                <select name="source" class="form-control" v-model="data.source_id">
                                    <option value="0">-- Selecteer --</option>
                                    <option v-for="source in getSources" :value="source.id">{{ source.name }}</option>
                                </select>
                                <div v-if="hasFormError('source')" class="help-block">{{ getFormErrors.filter(err => err.name === 'source')[0].errmsg }}</div>
                            </div>
                        </div>
                        <div :class="{'form-group':true,'has-error':hasFormError('type')}">
                            <label class="control-label col-xl-4">{{ lang.get("projects.type") }}:</label>
                            <div class="col-xl-8">
                                <select name="type" class="form-control" v-model="data.type_id">
                                    <option value="0">-- Selecteer --</option>
                                    <option v-for="type in getTypes" :value="type.id">{{ type.name }}</option>
                                </select>
                                <div v-if="hasFormError('type')" class="help-block">{{ getFormErrors.filter(err => err.name === 'type')[0].errmsg }}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.form.percentage") }}:</label>
                            <div class="col-xl-8">
                                <select name="contract_percentage" class="form-control" v-model="data.contract_percentage">
                                    <option value="0">0%</option>
                                    <option v-for="key in 100" :key="key" :value="key">{{ key }}%</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.category") }}:</label>
                            <div class="col-xl-8">
                                <select name="type" class="form-control" v-model="data.category_id">
                                    <option value="0">-- Selecteer --</option>
                                    <option v-for="category in getCategories" :value="category.id">{{ category.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("global.city") }}:</label>
                            <div class="col-xl-8">
                                <input type="text" class="form-control" v-model="data.city" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("global.country") }}:</label>
                            <div class="col-xl-8">
                                <v-select
                                    v-model="data.country_id"
                                    :options="allcountries"
                                    :reduce="entry => entry.value"
                                ></v-select>
                            </div>
                        </div>
                    </div>
                    <div class="overlay" v-show="isLoading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">{{ lang.get("projects.headers.projectteam") }}</h2>
                    </div>
                    <div class="box-body form-horizontal">
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.form.partner") }}:</label>
                            <div class="col-xl-8">
                                <div class="input-group">
                                    <input type="text" class="form-control" v-model="partner" disabled tabindex="1" />
                                    <span class="input-group-btn">
                                        <button class="btn btn-info btn-sm" @click="openOfficeSearch('single','partner')"><i class="mdi mdi-account-search"></i></button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div :class="{'form-group':true,'has-error':hasFormError('director_id')}">
                            <label class="control-label col-xl-4">{{ lang.get("projects.form.director") }}:</label>
                            <div class="col-xl-8">
                                <div class="input-group">
                                    <input type="text" class="form-control" v-model="director" disabled tabindex="1" />
                                    <span class="input-group-btn">
                                        <button class="btn btn-info btn-sm" @click="openOfficeSearch('single','director')"><i class="mdi mdi-account-search"></i></button>
                                    </span>
                                </div>
                                <div v-if="hasFormError('director_id')" class="help-block">{{ getFormErrors.filter(err => err.name === 'director_id')[0].errmsg }}</div>
                            </div>
                        </div>
                        <div :class="{'form-group':true,'has-error':hasFormError('team_id')}">
                            <label class="control-label col-xl-4">Team:</label>
                            <div class="col-xl-8">
                                <v-select
                                    v-model="data.team_id"
                                    :options="allTeams"
                                    :reduce="entry => entry.value"
                                ></v-select>
                                <div v-if="hasFormError('team_id')" class="help-block">{{ getFormErrors.filter(err => err.name === 'team_id')[0].errmsg }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="box-body no-padding">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>{{ lang.get("global.name") }}</th>
                                    <th>{{ lang.get("global.hours") }}</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody v-if="data.users.length === 0">
                                <tr>
                                    <td colspan="3">Er zijn nog geen gebruikers aan het team toegevoegd</td>
                                </tr>
                            </tbody>
                            <draggable
                                v-if="getOfficeUsers.length > 0 && data.users.length > 0"
                                v-model="data.users"
                                @start="drag=true"
                                @end="drag=false"
                                tag="tbody"
                            >
                                <tr v-if="data.users.length > 0" v-for="uuid in data.users">
                                    <td>{{ getFullName(uuid) }}</td>
                                    <td>{{ getHoursWorkedForProject(uuid) }}</td>
                                    <td class="text-right">
                                        <button @click="removeTeamMember(uuid)" class="btn btn-danger btn-sm"><i class="fa fa-times"></i></button>
                                    </td>
                                </tr>
                            </draggable>
                            <tfoot>
                                <tr>
                                    <td class="text-right" colspan="3">
                                        <button type="button" class="btn btn-primary" @click="openOfficeSearch('multi')"><i class="fa fa-plus"></i></button>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="overlay" v-show="isLoading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Expected</h2>
                    </div>
                    <div class="box-body form-horizontal">
                        <div :class="{'form-group':true,'has-error':hasFormError('startdate')}">
                            <label class="control-label col-xl-4">{{ lang.get("global.startdate") }}:</label>
                            <div class="col-xl-8">
                                <date-picker v-model="data.startdate" format="DD-MM-YYYY" type="date" lang="en"></date-picker>
                                <div v-if="hasFormError('startdate')" class="help-block">{{ getFormErrors.filter(err => err.name === 'startdate')[0].errmsg }}</div>
                            </div>
                        </div>
                        <div :class="{'form-group':true,'has-error':hasFormError('enddate')}">
                            <label class="control-label col-xl-4">{{ lang.get("global.enddate") }}:</label>
                            <div class="col-xl-8">
                                <date-picker v-model="data.enddate" format="DD-MM-YYYY" lang="en"></date-picker>
                                <div v-if="hasFormError('enddate')" class="help-block">{{ getFormErrors.filter(err => err.name === 'enddate')[0].errmsg }}</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.form.budget") }}</label>
                            <div class="col-xl-8">
                                <money v-model="budget" v-bind="money" class="form-control"></money>
                            </div>
                        </div>
                    </div>
                    <div class="box-body form-horizontal">
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.executiondate") }}:</label>
                            <div class="col-xl-8">
                                <date-picker v-model="data.executiondate" format="DD-MM-YYYY" lang="en"></date-picker>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.buildingtime") }}:</label>
                            <div class="col-xl-8">
                                <div class="input-group">
                                    <input type="text" class="form-control" v-model="data.buildingtime" />
                                    <div class="input-group-addon">
                                        {{ lang.get("global.months") }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.buildingarea") }}:</label>
                            <div class="col-xl-8">
                                <div class="input-group">
                                    <input type="text" class="form-control" v-model="data.buildingarea" />
                                    <div class="input-group-addon">
                                        m2
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.buildingcosts") }}:</label>
                            <div class="col-xl-8">
                                <money v-model="buildingcosts" v-bind="money" class="form-control"></money>
                            </div>
                        </div>
                    </div>
                    <div class="overlay" v-show="isLoading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
                <div class="box box-solid">
                    <div class="box-header">
                        <h2 class="box-title">Project</h2>
                    </div>
                    <div class="box-body form-horizontal">
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("global.status") }}:</label>
                            <div class="col-xl-8">
                                <select name="type" class="form-control" v-model="data.status_id">
                                    <option v-for="status in getStatuses" :value="status.id">{{ status.name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="control-label col-xl-4">{{ lang.get("projects.completion_percentage") }}:</label>
                            <div class="col-xl-8">
                                {{ data.completion_percentage }}%
                            </div>
                        </div>
                    </div>
                    <div class="overlay" v-show="isLoading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <project-form-contacts></project-form-contacts>
            </div>
        </div>
        <div class="text-right">
            <button type="button"
                :class="{'btn btn-primary':true,'disabled':!canSubmit}"
                @click="onSubmit()"
            >{{ lang.get("projects.project") }} {{ editing ? 'wijzigen' : 'toevoegen' }}</button>
        </div>
        <div class="modal fade" id="searchOfficeModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                        <h4 class="modal-title">Collega zoeken</h4>
                    </div>
                    <div class="modal-body text-right">
                        <button class="btn btn-primary btn-sm" type="button" @click="closeOfficeSearch()">Geselecteerde collega's gebruiken</button>
                    </div>
                    <div class="modal-body no-padding">
                        <table class="table table-striped" v-if="getOfficeUsers.length > 0">
                            <thead>
                                <tr>
                                    <th>Naam</th>
                                    <th>Uren</th>
                                    <th class="col-lg-2">Selecteer</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in allUsers" v-if="searchType !== 'partner' || (searchType === 'partner' && user.partnergroup === true)">
                                    <td>{{ user.fullname }}</td>
                                    <td>{{ hours[user.uuid] ? hours[user.uuid] : 0 }}</td>
                                    <td>
                                        <button v-if="selectionType === 'single'" @click="onOfficeUserSelect(user)" class="btn btn-primary btn-sm">Selecteer</button>
                                        <input type="checkbox" v-if="selectionType === 'multi'" v-model="data.users" :value="user.uuid" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-body text-right">
                        <button class="btn btn-primary btn-sm" type="button" @click="closeOfficeSearch()">Geselecteerde collega's gebruiken</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import ProjectFormContacts from './Formsections/Contacts';
import Lang from "../../Lang";
import { Compact } from 'vue-color';
import DatePicker from 'vue2-datepicker';
import draggable from 'vuedraggable';
import vSelect from 'vue-select';
import {Money} from 'v-money';
import moment from 'moment';

export default {

    components: {
        ProjectFormContacts,
        'compact-picker': Compact,
        DatePicker,
        draggable,
        vSelect,
        Money,
    },

    computed: {
        ...mapGetters([
            "getCategories",
            "getContacts",
            "getCounters",
            "getFormErrors",
            "getOfficeUsers",
            "getSources",
            "getStatuses",
            "getTypes",
            "getRoutes",
            "isLoading",
        ]),

        allUsers(){
            if (this.isLoading){
                return [];
            }
            return this.getOfficeUsers.concat(this.data.inactiveusers);
        },

        budget: {
            get() {
                return this.data.budget / 100;
            },
            set(budget){
                this.data.budget = budget * 100;
            }
        },

        buildingcosts: {
            get() {
                return this.data.buildingcosts / 100;
            },
            set(buildingcosts){
                this.data.buildingcosts = buildingcosts * 100;
            }
        },

        canSubmit(){
            // #449 / #46
            return (this.data.aq === true || this.data.project === true) &&
                !this.isLoading &&
                this.posturi !== '' &&
                this.data.source_id !== 0 &&
                this.data.type_id !== 0 &&
                this.data.director_id !== '' &&
                this.data.name !== '' &&
                this.data.startdate !== null &&
                this.data.enddate !== null
                ;
        },

        getPostData(){
            let data = this.data;
            data.contacts = this.getContacts;
            if (data.category_id === 0) data.category_id = null;
            // #287 rewrite date fields
            data.enddate = data.enddate !== null ? moment(data.enddate).format("YYYY-MM-DD") : null;
            data.executiondate = data.executiondate !== null ? moment(data.executiondate).format("YYYY-MM-DD") : null;
            data.startdate = data.startdate !== null ? moment(data.startdate).format("YYYY-MM-DD"): null;

            return data;
        },

        showAq(){
            return this.data.aq === true || this.data.project === false;
        }
    },

    data() {
        return {
            data: {
                aq:false,
                aqnr:'',
                budget:'0,00',
                buildingcosts:'0,00',
                buildingarea:0,
                buildingtime:0,
                category_id:0,
                city:'',
                color:'#ffffff',
                completion_percentage:0,
                contract_percentage:0,
                country_id:null,
                director_id:'',
                team_id:null,
                enddate:null,
                executiondate:null,
                name:'',
                partner_id:'',
                project:false,
                projectnr:'',
                projectnr_suffix:'',
                parent_uuid:'',
                shortname:'',
                source_id:0,
                startdate:null,
                status_id:'',
                type_id:0,
                inactiveusers:[],
                users:[],
            },
            allcountries:[],
            allTeams:[],
            director:'',
            editing:false,
            hours:[],
            lang:Lang,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '€ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            partner:'',
            posturi:'',
            searchType:'all',
            selectionType:'multi',
        }
    },

    destroyed(){
        this.setContacts({});
    },

    methods: {
        ...mapActions([
            "parseData",
            "setCategories",
            "setContacts",
            "setContactTypes",
            "setFormErrors",
            "setGroups",
            "setSources",
            "setStatuses",
            "setTypes",
            "setLoading",
            "setProjectUuid",
        ]),

        fire() {
            // Counters and office users (data endpoint) are required before the form data can be seeded
            Promise.all([axios.get(this.infoUri), this.parseData()])
            .then(([response]) => {
                let data = response.data.data;
                this.setCategories(data.categories);
                this.setContactTypes(data.contacttypes);
                this.setGroups(data.groups);
                this.setSources(data.sources);
                this.setStatuses(data.statuses);
                this.setTypes(data.types);
                this.posturi = data.uris.posturi;
                // Set default values
                this.setDefaultValues();
                // Check if data has been set
                if (data.data) {
                    this.editing = true;
                    this.seedFormData(data.data);
                }
                // Store local data
                this.allcountries = data.countries;
                this.setDefaultCountry();
                this.allTeams = data.teams;
                // Get the users
                this.getUsers();
                // Set loading to false
                this.setLoading(false);
            });
        },
        closeOfficeSearch() {
            $('#searchOfficeModal').modal('hide');
        },

        getFormattedCounter(type, number = null) {
            let counter = this.getCounters[type] || {};
            number = number !== null ? number : counter.number;
            if (counter.prefix){
                number = counter.prefix + "-" + number;
            }
            if (counter.suffix) {
                number = number + "-" + counter.suffix;
            }
            if (this.data.projectnr_suffix && this.data.projectnr_suffix !== "") {
                number = number + "-" + this.data.projectnr_suffix;
            }
            return number;
        },

        getFullName(uuid) {
            // Note: The this.getOfficeUsers collection only contains active users. Old users are simply not included.
            let res = this.allUsers.filter(usr => usr.uuid === uuid);
            if (res.length > 0) {
                return res[0].fullname;
            }
            return '';
        },

        getHoursWorkedForProject(uuid) {
            if (!this.hours[uuid]){
                return 0;
            }
            return this.hours[uuid];
        },

        getUsers(){
            if (this.editing && this.getOfficeUsers.length > 0){
                if (this.data.partner_id !== '') {
                    let res = this.getOfficeUsers.filter(usr => usr.uuid === this.data.partner_id);
                    if (res.length > 0) {
                        this.partner = res[0].fullname;
                    }
                }
                if (this.data.director_id !== '') {
                    // Get the filtered results
                    let res = this.getOfficeUsers.filter(usr => usr.uuid === this.data.director_id);
                    // Check res length
                    if (res.length > 0) {
                        // Store the director fullname
                        this.director = res[0].fullname;
                    }
                }
            }
        },

        hasFormError(field){
            if (this.isLoading) {
                return false;
            }
            if (typeof this.getFormErrors.length === "undefined"){
                return false;
            }
            return this.getFormErrors.filter(err => err.name === field).length > 0;
        },

        onOfficeUserSelect(user) {
            if (this.searchType === 'director') {
                this.data.director_id = user.uuid;
                this.director = user.fullname;
            } else if (this.searchType === 'partner') {
                this.data.partner_id = user.uuid;
                this.partner = user.fullname;
            }
            this.closeOfficeSearch();
        },

        onSubmit(){
            if (!this.canSubmit) {
                let errors = [];
                if (this.data.aq === false && this.data.project === false) {
                    errors.push({
                        name: "project",
                        errmsg: "Er moet tenminste een project nummer of acquisitie nummer geselecteerd zijn."
                    });
                }
                if (this.data.source_id === 0){
                    errors.push({
                        name: "source",
                        errmsg: "Er is nog geen Bron geselecteerd",
                    });
                }
                if (this.data.type_id === 0){
                    errors.push({
                        name: "type",
                        errmsg: "Er is nog geen Type geselecteerd",
                    });
                }
                if (this.data.director_id === '') {
                    errors.push({
                        name: "director_id",
                        errmsg: "Er is nog geen Project Regisseur geselecteerd",
                    });
                }
                if (this.data.name === '') {
                    errors.push({
                        name: "name",
                        errmsg: "Er is nog geen Project naam ingevoerd",
                    });
                }
                if (this.data.shortname === '') {
                    errors.push({
                        name: "shortname",
                        errmsg: "Er is nog geen Korte naam ingevoerd",
                    });
                }
                if (this.data.startdate === null) {
                    errors.push({
                        name: "startdate",
                        errmsg: "Er is geen startdatum ingesteld",
                    });
                }
                if (this.data.enddate === null) {
                    errors.push({
                        name: "enddate",
                        errmsg: "Er is geen einddatum ingesteld",
                    });
                }
                this.setFormErrors(errors);
                return false;
            }
            this.setLoading(true);
            axios.post(this.posturi, this.getPostData)
                .then(response => {
                    if (response.data.success) {
                        this.$snotify.success(this.editing === true ? 'Het project is aangepast' : 'Het project is aangemaakt.');
                        this.$emit('reloadProjectData');
                        this.$router.push({
                            name:'projects.details.index',
                            params:{
                                uuid:response.data.data.project_uuid
                            }
                        });
                    } else {
                        this.$snotify.error('Er is een technische fout opgetreden bij het verwerken van de projectgegevens.');
                    }
                })
                .catch(() => this.$snotify.error('Er is een fout opgetreden bij het opslaan van het project'))
                .finally(() => this.setLoading(false));
        },

        openOfficeSearch(selectionType = 'multi', searchType = 'all') {
            this.selectionType = selectionType;
            this.searchType = searchType;
            $('#searchOfficeModal').modal('show');
        },

        removeTeamMember(uuid) {
            this.data.users.splice(this.data.users.findIndex((usr) => usr === uuid), 1);
        },

        seedFormData(data) {
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    // Set data if it exists in the vue data object
                    if (typeof this.data[key] !== "undefined") {
                        this.data[key] = data[key];
                    }
                }
            }
            if (this.data.project === true) {
                this.data.projectnr = this.getFormattedCounter("project", data.projectnr);
            }
            // Update all non-post-data parameters so they have to correct data.
            this.data.startdate = moment(new Date(this.data.startdate * 1000).toISOString()).toDate();
            this.data.enddate = moment(new Date(this.data.enddate * 1000).toISOString()).toDate();
            this.data.executiondate = moment(new Date(this.data.executiondate * 1000).toISOString()).toDate();
            if (data.contacts && typeof data.contacts === "object") {
                // Loop all contacts
                this.setContacts(data.contacts);
            }
            if (data.hours) {
                this.hours = data.hours;
            }
        },

        setDefaultValues() {
            // Set default values
            this.data.status_id = this.getStatuses[0].id;
        },

        setAq(){
            if (confirm("Weet je zeker dat je een acquisitienummer wilt toewijzen aan dit project?")) {
                this.data.aq = true;
                this.data.aqnr = this.getFormattedCounter("aq");
            }
        },

        setProject(){
            if (confirm("Weet je zeker dat je een projectnummer wilt toewijzen aan dit project?")) {
                this.data.project = true;
                this.data.projectnr = this.getFormattedCounter("project");
            }
        },

        updateColorValue(e) {
            this.data.color = e.hex;
        },

        setDefaultCountry() {
            if (this.editing === true) {
                return;
            }

            let defaultcountry = this.allcountries.filter(country => {
                return country.label === 'Nederland' ||
                    country.label === 'The Netherlands';
            });
            if (defaultcountry.length > 0) {
                this.data.country_id = defaultcountry[0].value;
            }
        },
    },

    mounted() {
        if (this.formErrors) {
            this.setFormErrors(JSON.parse(this.formErrors));
        }
        if (this.projectuuid) {
            this.setProjectUuid(this.projectuuid);
        }
        this.fire();
    },

    name: "ProjectForm",

    props: {
        formErrors: {
            type: String,
            default: null,
        },
        infoUri: {
            required: true,
            type: String,
        },
        projectuuid: {
            type: String,
            default: null,
        },
    }
}

</script>
